enum AccessoryTypeEnum {
  IncludedAccessories = 'IncludedAccessories',
  OptionalAccessories = 'OptionalAccessories',
}

export default AccessoryTypeEnum;
